import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { get } from 'lodash';
import { Field, FieldArray } from 'redux-form';
import { v4 as uuid } from 'uuid';
import { LEARNING_ASSET_TYPES } from '../../../../../shared/Constants';

import DisplayOnlyInput from '../../../../../shared/components/formComponents/inputs/DisplayOnlyInput';

import RenderSectionItems from './RenderSectionItems';

class RenderSections extends Component {
    static propTypes = {
        fields: PropTypes.any,
        type: PropTypes.oneOf([
            LEARNING_ASSET_TYPES.TRACK,
            LEARNING_ASSET_TYPES.ACTIVITY,
            LEARNING_ASSET_TYPES.ARTICLE,
            LEARNING_ASSET_TYPES.VIDEO,
            LEARNING_ASSET_TYPES.IMPACT_PROJECT,
            LEARNING_ASSET_TYPES.SINGLE_PAGE_ACTIVITY,
            LEARNING_ASSET_TYPES.ASSESSMENT,
            LEARNING_ASSET_TYPES.PRE_ASSESSMENT,
            LEARNING_ASSET_TYPES.POST_ASSESSMENT,
            LEARNING_ASSET_TYPES.FEEDBACK,
            LEARNING_ASSET_TYPES.PRACTICAL_APPLICATION,
            LEARNING_ASSET_TYPES.REFLECTION
        ]),
        selectedSectionId: PropTypes.string,
        selectedSectionItemId: PropTypes.string,
        currentFormValues: PropTypes.object,
        basePath: PropTypes.string,
        reviewItems: PropTypes.object,
        sectionSelected: PropTypes.func.isRequired,
        sectionItemSelected: PropTypes.func.isRequired,
        changeFormValue: PropTypes.func,
        hideForContentAuthor: PropTypes.bool
    };

    _getFormValue(fieldName) {
        return get(this.props.currentFormValues, fieldName, '');
    }

    _createNewSection = () => {
        const newSectionId = uuid();
        this.props.fields.push({
            id: newSectionId,
            name: 'Section',
            sectionIcon: 'asterisk',
            isIncludedInCompletionRate: true
        });
        this.props.sectionSelected(newSectionId);
    };

    /**
     * * Checks to see if the add section button should be disabled
     * @return {boolean}
     * @private
     */
    _isAddSectionButtonDisabled = () => {
        const { type, fields } = this.props;

        const fieldsLength = get(fields, 'length', 0);
        if (
            (type === LEARNING_ASSET_TYPES.ACTIVITY && fieldsLength >= 1) ||
            (type === LEARNING_ASSET_TYPES.FEEDBACK && fieldsLength >= 1) ||
            type === LEARNING_ASSET_TYPES.ARTICLE ||
            type === LEARNING_ASSET_TYPES.VIDEO ||
            type === LEARNING_ASSET_TYPES.WELCOME ||
            type === LEARNING_ASSET_TYPES.SINGLE_PAGE_ACTIVITY
        ) {
            return true;
        }
        return false;
    };

    render() {
        const {
            fields,
            type,
            selectedSectionId,
            selectedSectionItemId,
            sectionSelected,
            changeFormValue,
            basePath,
            hideForContentAuthor,
            reviewItems = {}
        } = this.props;
        const renderedSections = fields.map((member, index) => {
            const currentSectionId = this._getFormValue(`${member}.id`);
            return (
                <div key={index}>
                    <h4
                        onClick={() => sectionSelected(currentSectionId)}
                        className={cns('trackSectionTitle', 'selectableTrackSectionTitle', {
                            active: currentSectionId === selectedSectionId
                        })}
                    >
                        <i className={cns('icon')} />
                        <Field name={`${member}.name`} component={DisplayOnlyInput} />
                    </h4>
                    <FieldArray
                        name={`${member}.sectionItems`}
                        type={type}
                        component={RenderSectionItems}
                        changeFormValue={changeFormValue}
                        currentFormValues={this.props.currentFormValues}
                        reviewItems={reviewItems}
                        sectionItemSelected={this.props.sectionItemSelected}
                        sectionId={currentSectionId}
                        basePath={basePath}
                        selectedSectionItemId={selectedSectionItemId}
                    />
                </div>
            );
        });

        return (
            <div className={'sectionWrapper'}>
                {renderedSections}
                {!hideForContentAuthor && (
                    <h4
                        className={'trackSectionTitle'}
                        key={'addNewSection'}
                        disabled={this._isAddSectionButtonDisabled()}
                    >
                        <i
                            onClick={this._createNewSection}
                            disabled={this._isAddSectionButtonDisabled()}
                            className={'icon addSection fa fa-plus fa-large'}
                        />
                        Add Section
                    </h4>
                )}
            </div>
        );
    }
}

export default RenderSections;
